"use client"

import { ErrorBoundary } from "@sentry/nextjs"
import MarketingHeading from "../common/MarketingHeading"
import { MasonryAPIViewer } from "./masonry/MasonryAPIViewer"
import { MasonryBigQueryViewer } from "./masonry/MasonryBigQueryViewer"
import { MasonryChartWidget } from "./masonry/MasonryChartWidget"
import { MasonryFinancialStatement } from "./masonry/MasonryFinancialStatement"
import { MasonryLeaderboard } from "./masonry/MasonryLeaderboard"
import { MasonryQueryEditor } from "./masonry/MasonryQueryEditor"
import { MasonrySheetsWidget } from "./masonry/MasonrySheetsWidget"
import { MasonryTreeMap } from "./masonry/MasonryTreeMap"

function ProductShowcaseMasonry() {
  return (
    <div className="w-full overflow-hidden py-20">
      <div className="max-w-[1240px] mx-auto mb-12">
        <MarketingHeading
          level={2}
          className="text-center text-[32px] leading-[0.9em] lg:text-[40px] md:max-w-[550px] mx-auto"
        >
          Onchain fundamentals
          <br />
          you can understand
        </MarketingHeading>
      </div>

      <div className="relative w-full">
        <div className="max-w-[1400px] mx-auto">
          <div className="hidden lg:grid grid-cols-3 gap-6">
            <div className="col-span-2">
              <ErrorBoundary>
                <MasonryChartWidget />
              </ErrorBoundary>
            </div>
            <div className="col-span-1">
              <ErrorBoundary>
                <MasonryLeaderboard />
              </ErrorBoundary>
            </div>

            <div className="col-span-1">
              <ErrorBoundary>
                <MasonryTreeMap />
              </ErrorBoundary>
            </div>
            <div className="col-span-1">
              <ErrorBoundary>
                <MasonryFinancialStatement />
              </ErrorBoundary>
            </div>

            <div className="col-span-1">
              <ErrorBoundary>
                <MasonryQueryEditor />
              </ErrorBoundary>
            </div>
            <div className="col-span-1">
              <ErrorBoundary>
                <MasonrySheetsWidget />
              </ErrorBoundary>
            </div>
            <div className="col-span-1">
              <ErrorBoundary>
                <MasonryAPIViewer />
              </ErrorBoundary>
            </div>

            <div className="col-span-1">
              <ErrorBoundary>
                <MasonryBigQueryViewer />
              </ErrorBoundary>
            </div>
          </div>

          <div className="hidden md:flex lg:hidden flex-col gap-6">
            <div className="grid grid-cols-2 gap-6">
              <ErrorBoundary>
                <MasonryChartWidget />
              </ErrorBoundary>
              <ErrorBoundary>
                <MasonryLeaderboard />
              </ErrorBoundary>
            </div>

            <div className="grid grid-cols-3 gap-6">
              <ErrorBoundary>
                <MasonryTreeMap />
              </ErrorBoundary>
              <ErrorBoundary>
                <MasonryFinancialStatement />
              </ErrorBoundary>
              <ErrorBoundary>
                <MasonryQueryEditor />
              </ErrorBoundary>
            </div>

            <div className="grid grid-cols-3 gap-6">
              <ErrorBoundary>
                <MasonrySheetsWidget />
              </ErrorBoundary>
              <ErrorBoundary>
                <MasonryAPIViewer />
              </ErrorBoundary>
              <ErrorBoundary>
                <MasonryBigQueryViewer />
              </ErrorBoundary>
            </div>
          </div>

          <div className="flex flex-col gap-6 md:hidden">
            <ErrorBoundary>
              <MasonryChartWidget />
            </ErrorBoundary>
            <ErrorBoundary>
              <MasonryLeaderboard />
            </ErrorBoundary>
            <ErrorBoundary>
              <MasonryTreeMap />
            </ErrorBoundary>
            <ErrorBoundary>
              <MasonryFinancialStatement />
            </ErrorBoundary>
            <ErrorBoundary>
              <MasonryQueryEditor />
            </ErrorBoundary>
            <ErrorBoundary>
              <MasonrySheetsWidget />
            </ErrorBoundary>
            <ErrorBoundary>
              <MasonryAPIViewer />
            </ErrorBoundary>
            <ErrorBoundary>
              <MasonryBigQueryViewer />
            </ErrorBoundary>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProductShowcaseMasonry
